import { useTranslation } from 'react-i18next';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faLockOpen } from '@fortawesome/pro-regular-svg-icons/faLockOpen';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, theme, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { isWithinNextXDays } from 'pos-client/utils/dayjs.ts';
import { scheduleBoardJobPartStatus } from 'pos-client/utils/order/jobBuilderUtils.ts';
import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

import { JobStatusIcon } from './JobStatusIcon.tsx';

interface JobSlotContentIconsProps {
  state?: string;
  slotType: string | null | undefined;
  jobData: ScheduleBoardJobModel;
}

export const JobSlotContentStatusIcons = ({
  state,
  slotType,
  jobData,
}: JobSlotContentIconsProps) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const partsNotOrdered =
    isWithinNextXDays(dayjs(jobData.startDate), 2) &&
    scheduleBoardJobPartStatus(jobData.items ?? []) === 'notOrdered';

  return (
    <Flex
      style={{
        fontSize: token.fontSizeSM,
        position: 'absolute',
        right: '-2px',
        top: '-2px',
        flexDirection: 'column',
        gap: 9,
        padding: 0,
      }}
    >
      {!partsNotOrdered && state && <JobStatusIcon status={state} />}
      {partsNotOrdered && (
        <Tooltip title={t('statuses.partNotThereYet')}>
          <FontAwesomeIcon icon={faTriangleExclamation} color={token.red8} />
        </Tooltip>
      )}
      {slotType?.toLowerCase() === 'fixed' ? (
        <FontAwesomeIcon icon={faLock} />
      ) : (
        <FontAwesomeIcon icon={faLockOpen} />
      )}
    </Flex>
  );
};
